__turbopack_context__.v({
  "card": "vBPi3a_card",
  "contactCards": "vBPi3a_contactCards",
  "contactCardsHeader": "vBPi3a_contactCardsHeader",
  "contactCardsWrapper": "vBPi3a_contactCardsWrapper",
  "singleText": "vBPi3a_singleText",
});
